// import React, { useState, useEffect } from "react";
// import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
// import CommonReactTable from "../CommonUtils/CommonReactTable";
// import { config } from "../CommonUtils/CommonURLS";
// import Swal from "sweetalert2";
// import { FaCheckCircle } from "react-icons/fa";
// import { Modal } from "react-bootstrap";
// import { useRef } from "react";
// import { useReactToPrint } from "react-to-print";
// export default function FacultyReport() {
//     const ROLEID = sessionStorage.getItem("role_id");
//     const tableRef = useRef(null);

//     const handlePrint = useReactToPrint({
//         contentRef: tableRef,
//         documentTitle: "Faculty Details",
//     });


//     const [projectdata, setProjectdata] = useState([]);
//     const [selectedRows, setSelectedRows] = useState({}); // store selected rows by sno

//     function GetProjectStatusData() {
//         const url = `${config.url.FAC_URL}getFacultyDetails`;
//         CommonAxiosGet(url).then((res) => {
//             if (res?.data?.scode === "01" && res?.data?.fac_details?.length > 0) {
//                 setProjectdata(res?.data?.fac_details);
//             } else {
//                 setProjectdata([]);
//             }
//         });
//     }

//     function handleSendBack(cfmsId) {

//         Swal.fire({
//             title: "Send Back to Maker?",
//             text: `CFMS ID: ${cfmsId}`,
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonText: "Yes, Send Back",
//             cancelButtonText: "Cancel",
//             confirmButtonColor: "#d33",
//             backdrop: false
//         }).then((result) => {

//             if (result.isConfirmed) {

//                 const url = `${config.url.FAC_URL}sendBackFacultyCfmsData?cfmsId=${cfmsId}`;

//                 CommonAxiosPost(url).then((res) => {

//                     if (res?.data?.scode === "01") {

//                         Swal.fire(
//                             res?.data?.sdesc || "Sent back successfully",
//                             "",
//                             "success"
//                         );

//                         GetProjectStatusData();

//                     } else {

//                         Swal.fire(
//                             res?.data?.sdesc || "Operation failed",
//                             "",
//                             "error"
//                         );

//                     }

//                 });

//             }

//         });
//     }

//     function handleBulkApprove() {
//         const slnoList = Object.keys(selectedRows)
//             .filter((key) => selectedRows[key])
//             .map((key) => Number(key));

//         if (slnoList.length === 0) {
//             Swal.fire("Please select at least one faculty to approve", "", "warning");
//             return;
//         }

//         const selectedFaculties = projectdata
//             .filter((row) => slnoList.includes(row.sno))
//             .map((row) => `${row.fac_name} (CFMS ID: ${row.cfms_id})`)
//             .join("<br/>");

//         Swal.fire({
//             title: "Confirm Approval",
//             html: `<strong>Selected Faculty:</strong><br/>${selectedFaculties}`,
//             icon: "warning",
//             showCancelButton: true,
//             confirmButtonText: "Yes, Approve!",
//             cancelButtonText: "Cancel",
//             backdrop: false,
//             confirmButtonColor: "#2e7d32",
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 const url = `${config.url.FAC_URL}updateCheckerApprovalFaculty`;
//                 const payload = {
//                     isCheckerApproved: true,
//                     slnolist: slnoList,
//                 };
//                 CommonAxiosPost(url, payload).then((res) => {
//                     if (res?.data?.scode === "01") {
//                         Swal.fire(res?.data?.sdesc || "Approved successfully", "", "success");
//                         setSelectedRows({});
//                         GetProjectStatusData();
//                     } else {
//                         Swal.fire(res?.data?.sdesc || "Approval failed", "", "error");
//                     }
//                 });
//             }
//         });
//     }


//     const [facdashboardcount, setFacdashboardcount] = useState([]);
//     function DashBoardCountFac() {
//         let url = `${config.url.FAC_URL}getUnvWisefacDashboardcount`;
//         CommonAxiosGet(url).then((res) => {
//             if (res?.data?.scode === "01") {
//                 setFacdashboardcount(res?.data?.UnivsubWiseReport || []);
//             } else {
//                 setFacdashboardcount([]);
//             }
//         });
//     }

//     const [showModal, setShowModal] = useState(false);
//     const [facultyDetails, setFacultyDetails] = useState(null);

//     const openBasicDetailsModal = (data) => {
//         setFacultyDetails(data);
//         setShowModal(true);
//     };


//     const FacultyReportColumns = [
//         {
//             id: "S No",
//             header: ROLEID === "4" ? (
//                 <input
//                     type="checkbox"
//                     onChange={(e) => {
//                         const checked = e.target.checked;
//                         const newSelected = {};
//                         projectdata.forEach((row) => {
//                             if (!row.is_checker_approved) newSelected[row.sno] = checked;
//                         });
//                         setSelectedRows(newSelected);
//                     }}
//                     checked={
//                         projectdata.filter((r) => !r.is_checker_approved).every((r) => selectedRows[r.sno])
//                     }
//                 />
//             ) : "S.No",
//             cell: ({ row }) => (
//                 <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//                     {ROLEID === "4" && !row.original.is_checker_approved && (
//                         <input
//                             type="checkbox"
//                             checked={!!selectedRows[row.original.sno]}
//                             onChange={(e) =>
//                                 setSelectedRows((prev) => ({
//                                     ...prev,
//                                     [row.original.sno]: e.target.checked,
//                                 }))
//                             }
//                         />
//                     )}
//                     <span>{row.index + 1}</span>
//                 </div>
//             ),
//         },
//         {
//             id: "cfms_id",
//             header: "CFMS ID",
//             accessorKey: "cfms_id",
//         },
//         {
//             id: "fac_name",
//             header: "Faculty Name",
//             accessorKey: "fac_name",
//             meta: { style: { textAlign: "left" } },
//         },


//         {
//             id: "masked_aadhar",
//             header: "Adhaar No",
//             accessorKey: "masked_aadhar",
//             meta: { style: { textAlign: "left" } },
//         },
//         {
//             id: "gender",
//             header: "Gender",
//             accessorKey: "gender",
//         },


//         {
//             id: "dob",
//             header: "Date of Birth",
//             accessorKey: "dob",
//             cell: ({ getValue }) => {
//                 const value = getValue();
//                 if (!value) return "";

//                 const date = new Date(value);
//                 return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
//             }
//         },
//         {
//             id: "designation",
//             header: "Designation",
//             accessorKey: "designation",
//             meta: { style: { textAlign: "left" } },
//         },
//         {
//             id: "doj",
//             header: "Date of Joining in the University",
//             accessorKey: "doj",
//             meta: { style: { textAlign: "left" } },
//             cell: ({ getValue }) => {
//                 const value = getValue();
//                 if (!value) return "";

//                 const date = new Date(value);
//                 return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
//             }
//         },

//         {
//             id: "dept_name",
//             header: "Department / Subject",
//             accessorKey: "dept_name",
//             meta: { style: { textAlign: "left" } },
//         },


//         {
//             id: "fac_type_name",
//             header: "Type of Faculty",
//             accessorKey: "fac_type_name",
//             meta: { style: { textAlign: "left" } },
//         },

//         {
//             id: "appoint_cat_name",
//             header: "Appointed Category",
//             accessorKey: "appoint_cat_name",
//             meta: { style: { textAlign: "left" } },
//         },
//         {
//             id: "design_time_of_appointment",
//             header: "Designation at the time of Appointment",
//             accessorKey: "design_time_of_appointment",
//             meta: { style: { textAlign: "left" } },
//         },


//         {
//             id: "qualification_appoint_name",
//             header: "Qualifications at the Time of Appointment",
//             accessorKey: "qualification_appoint_name",
//             meta: { style: { textAlign: "left" } },
//             cell: ({ getValue }) => {
//                 const value = getValue() || "";
//                 const items = value.split(",").map((item) => item.trim()).filter(Boolean);
//                 return (
//                     <span>
//                         {items.map((item, idx) => (
//                             <React.Fragment key={idx}>
//                                 {item}
//                                 {idx < items.length - 1 && <span>, </span>}
//                             </React.Fragment>
//                         ))}
//                     </span>
//                 );
//             },
//         },
//         {
//             id: "qualification_later_name",
//             header: "Qualification Acquired Later",
//             accessorKey: "qualification_later_name",
//             meta: { style: { textAlign: "left" } },
//             cell: ({ getValue }) => {
//                 const value = getValue() || "";
//                 const items = value.split(",").map((item) => item.trim()).filter(Boolean);
//                 return (
//                     <span>
//                         {items.map((item, idx) => (
//                             <React.Fragment key={idx}>
//                                 {item}
//                                 {idx < items.length - 1 && <span>, </span>}
//                             </React.Fragment>
//                         ))}
//                     </span>
//                 );
//             },
//         },


//         {
//             id: "basic_details",
//             header: "view more details & print",
//             cell: ({ row }) => (
//                 <button
//                     className="btn-basic-details"
//                     onClick={() => openBasicDetailsModal(row.original)}
//                 >
//                     view Details
//                 </button>
//             ),
//         },
//         ...(ROLEID === "4"
//             ? [

//                 {
//                     id: "approve",
//                     header: "Approve",
//                     cell: ({ row }) => {
//                         const { is_checker_approved, cfms_id } = row.original;

//                         if (is_checker_approved) {
//                             return (
//                                 <span className="status-badge status-approved">
//                                     <FaCheckCircle size={16} />
//                                     Approved
//                                 </span>
//                             );
//                         } else {
//                             return (
//                                 <button
//                                     className="btn-back-to-maker"
//                                     onClick={() => handleSendBack(cfms_id)}
//                                 >
//                                     Back to Maker
//                                 </button>
//                             );
//                         }
//                     },
//                 }
//             ]
//             : []),


//     ];

//     useEffect(() => {
//         GetProjectStatusData();
//         DashBoardCountFac();
//     }, []);
//     const totalCount = facdashboardcount?.reduce((acc, item) => {
//         return acc + Number(item.total || 0);
//     }, 0);



//     return (

//         <>



//             <Modal
//                 show={showModal}
//                 onHide={() => setShowModal(false)}
//                 centered
//                 backdrop="static"
//                 keyboard={false}
//                 animation={false}
//                 dialogClassName="modal-xxxl"
//             >

//                 <Modal.Header closeButton className="faculty-modal-header">
//                     <Modal.Title>Faculty Complete Details</Modal.Title>
//                 </Modal.Header>

//                 <Modal.Body className="report-modal-body">

//                     <div ref={tableRef} className="faculty-report">

//                         {/* Personal Details */}

//                         <h5 className="report-section">Personal Details</h5>

//                         <div className="report-row">
//                             <div><b>CFMS ID:</b> {facultyDetails?.cfms_id}</div>
//                             <div><b>Faculty Name:</b> {facultyDetails?.fac_name}</div>
//                         </div>

//                         <div className="report-row">
//                             <div><b>Aadhar:</b> {facultyDetails?.masked_aadhar}</div>
//                             <div><b>Gender:</b> {facultyDetails?.gender}</div>
//                         </div>

//                         <div className="report-row">
//                             <div><b>Date of Birth:</b> {facultyDetails?.dob}</div>
//                             <div><b>Caste:</b> {facultyDetails?.caste}</div>
//                         </div>

//                         <div className="report-row">
//                             <div><b>Sub Caste:</b> {facultyDetails?.sub_caste_name}</div>
//                             <div><b>Physically Challenged:</b> {facultyDetails?.is_ph ? "Yes" : "No"}</div>
//                         </div>

//                         <div className="report-row">
//                             <div><b>Type of Disability:</b> {facultyDetails?.type_of_disability}</div>
//                             <div><b>Disability Percentage:</b> {facultyDetails?.per_disability}</div>
//                         </div>


//                         {/* Appointment Details */}

//                         <h5 className="report-section">Appointment Details</h5>

//                         <div className="report-row">
//                             <div><b>Designation:</b> {facultyDetails?.designation}</div>
//                             <div><b>Department:</b> {facultyDetails?.dept_name}</div>
//                         </div>

//                         <div className="report-row">
//                             <div><b>Date of Joining:</b> {facultyDetails?.doj}</div>
//                             <div><b>Faculty Type:</b> {facultyDetails?.fac_type_name}</div>
//                         </div>

//                         <div className="report-row">
//                             <div><b>Appointed Category:</b> {facultyDetails?.appoint_cat_name}</div>
//                             <div><b>District:</b> {facultyDetails?.dist_name}</div>
//                         </div>


//                         {/* Contact Details */}

//                         <h5 className="report-section">Contact Details</h5>

//                         <div className="report-row">
//                             <div><b>Mobile Number:</b> {facultyDetails?.contact}</div>
//                             <div><b>Email:</b> {facultyDetails?.email_id}</div>
//                         </div>


//                         {/* Qualification */}

//                         <h5 className="report-section">Qualification</h5>

//                         <div className="report-row">
//                             <div><b>Qualification at Appointment:</b> {facultyDetails?.qualification_appoint_name}</div>
//                             <div><b>Qualification Acquired Later:</b> {facultyDetails?.qualification_later_name}</div>
//                         </div>

//                     </div>

//                 </Modal.Body>

//                 <Modal.Footer>

//                     <button
//                         className="btn btn-primary"
//                         onClick={handlePrint}
//                     >
//                         Print
//                     </button>

//                     <button
//                         className="btn btn-secondary"
//                         onClick={() => setShowModal(false)}
//                     >
//                         Close
//                     </button>

//                 </Modal.Footer>

//             </Modal>
//             <div className='fac-topbar'>

//                 <div className='fac-detnew'>
//                     <h5 className='mb-0'>{ROLEID === "4" ? "Faculty Details Approval Form" : "Faculty Details Report"}</h5>
//                 </div>

//             </div>
//             {projectdata?.length > 0 && (<>
//                 <div className="fac-dashboard-container">

//                     <div className="newdd-cards">
//                         <h5 className="fac-title">Total</h5>

//                         <div className="fac-count-box">
//                             <span className="fac-count-value">{totalCount}</span>
//                         </div>
//                     </div>

//                     {facdashboardcount?.map((item, index) => (
//                         <div key={index} className="newdd-cards">

//                             <h5 className="fac-title">{item.fac_type_name}</h5>

//                             <div className="fac-count-box">
//                                 <span className="fac-count-value">{item.total}</span>
//                             </div>

//                         </div>
//                     ))}

//                 </div>
//             </>)}
//             <div className="faculty-form-wrapper">
//                 <div className="faculty-card">

//                     {projectdata?.length > 0 ? (
//                         // <div className="table-responsive">
//                         <CommonReactTable
//                             data={projectdata}
//                             columns={FacultyReportColumns}
//                             filename="Faculty Details Report"
//                             headerName={ROLEID === "4" ? "Faculty Details Approval" : "Faculty Details Report"}
//                             showPagination={true}
//                             showExcel={true}
//                             showPrint={true}
//                             showFooter={false}
//                             excelFileName="Faculty Details Report"


//                         />
//                         // </div>
//                     ) : (
//                         <center className="text-danger h5">**** No Data Found ****</center>
//                     )}

//                     {ROLEID === "4" && projectdata?.length > 0 && (
//                         <div className="text-end mt-3">
//                             <button
//                                 type="button"
//                                 className="submit-btn btn-sm btn"
//                                 style={{ marginBottom: "10px" }}
//                                 onClick={handleBulkApprove}
//                                 disabled={!Object.values(selectedRows).some(Boolean)}
//                             >
//                                 Approve Selected
//                             </button>
//                         </div>
//                     )}
//                 </div>
//             </div>

//         </>
//     );
// }

import React, { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import { FaCheckCircle } from "react-icons/fa";
import { Modal } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import { config } from "../CommonUtils/CommonURLS";

// ---------- Shared helpers (also imported by NonTeachingFacultyDetailsRepo.jsx) ----------

const leftAlign = { style: { textAlign: "left" } };

// DD/MM/YYYY
export const formatDate = (value) =>
  value ? new Date(value).toLocaleDateString("en-GB") : "";

export const textColumn = (id, header, { alignLeft = true } = {}) => ({
  id,
  header,
  accessorKey: id,
  ...(alignLeft && { meta: leftAlign }),
});

export const dateColumn = (id, header) => ({
  id,
  header,
  accessorKey: id,
  meta: leftAlign,
  cell: ({ getValue }) => formatDate(getValue()),
});

export const commaListColumn = (id, header) => ({
  id,
  header,
  accessorKey: id,
  meta: leftAlign,
  cell: ({ getValue }) =>
    (getValue() || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean)
      .join(", "),
});

export const selectColumn = ({ isChecker, selection }) => ({
  id: "S No",
  header: isChecker ? (
    <input
      type="checkbox"
      checked={selection.allSelected}
      onChange={(e) => selection.toggleAll(e.target.checked)}
    />
  ) : (
    "S.No"
  ),
  cell: ({ row }) => (
    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
      {isChecker && !row.original.is_checker_approved && (
        <input
          type="checkbox"
          checked={!!selection.selectedRows[row.original.sno]}
          onChange={(e) => selection.toggleRow(row.original.sno, e.target.checked)}
        />
      )}
      <span>{row.index + 1}</span>
    </div>
  ),
});

export const detailsColumn = (onView) => ({
  id: "basic_details",
  header: "View More Details & Print",
  cell: ({ row }) => (
    <button className="btn-basic-details" onClick={() => onView(row.original)}>
      View Details
    </button>
  ),
});

export const approveColumn = (onSendBack) => ({
  id: "approve",
  header: "Approve",
  cell: ({ row }) => {
    const { is_checker_approved, cfms_id } = row.original;
    return is_checker_approved ? (
      <span className="status-badge status-approved">
        <FaCheckCircle size={16} /> Approved
      </span>
    ) : (
      <button className="btn-back-to-maker" onClick={() => onSendBack?.(cfms_id)}>
        Back to Maker
      </button>
    );
  },
});

export function useRowSelection(rows) {
  const [selectedRows, setSelectedRows] = useState({});
  const pending = rows.filter((r) => !r.is_checker_approved);

  const allSelected = pending.length > 0 && pending.every((r) => selectedRows[r.sno]);
  const hasSelection = Object.values(selectedRows).some(Boolean);
  const selectedIds = Object.keys(selectedRows)
    .filter((k) => selectedRows[k])
    .map(Number);

  const toggleAll = (checked) => {
    const next = {};
    pending.forEach((r) => {
      next[r.sno] = checked;
    });
    setSelectedRows(next);
  };

  const toggleRow = (sno, checked) =>
    setSelectedRows((prev) => ({ ...prev, [sno]: checked }));

  const clear = () => setSelectedRows({});

  return { selectedRows, allSelected, hasSelection, selectedIds, toggleAll, toggleRow, clear };
}

// sections = [{ title, rows: [ [[label, value], [label, value]], ... ] }]
export function FacultyDetailsModal({ show, onHide, title, sections, printRef, onPrint }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      animation={false}
      dialogClassName="modal-xxxl"
    >
      <Modal.Header closeButton className="faculty-modal-header">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="report-modal-body">
        <div ref={printRef} className="faculty-report">
          {sections.map((section) => (
            <React.Fragment key={section.title}>
              <h5 className="report-section">{section.title}</h5>
              {section.rows.map((pair, i) => (
                <div className="report-row" key={i}>
                  {pair.map(([label, value]) => (
                    <div key={label}>
                      <b>{label}:</b> {value}
                    </div>
                  ))}
                </div>
              ))}
            </React.Fragment>
          ))}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-primary" onClick={onPrint}>
          Print
        </button>
        <button className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export function FacultyReportLayout({
  title,
  data,
  columns,
  isChecker,
  hasSelection,
  onBulkApprove,
  children, // optional content between top bar and table (dashboard cards)
}) {
  return (
    <>
      <div className="fac-topbar">
        <div className="fac-detnew">
          <h5 className="mb-0">{title}</h5>
        </div>
      </div>

      {children}

      <div className="faculty-form-wrapper">
        <div className="faculty-card">
          {data.length > 0 ? (
            <CommonReactTable
              data={data}
              columns={columns}
              filename={title}
              headerName={title}
              excelFileName={title}
              showPagination={true}
              showExcel={true}
              showPrint={true}
              showFooter={false}
            />
          ) : (
            <center className="text-danger h5">**** No Data Found ****</center>
          )}

          {isChecker && data.length > 0 && (
            <div className="text-end mt-3">
              <button
                type="button"
                className="submit-btn btn-sm btn"
                style={{ marginBottom: "10px" }}
                onClick={onBulkApprove}
                disabled={!hasSelection}
              >
                Approve Selected
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

// ---------- Teaching faculty page ----------

export default function FacultyReport() {
  const isChecker = sessionStorage.getItem("role_id") === "4";
  const printRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: "Faculty Details",
  });

  const [projectdata, setProjectdata] = useState([]);
  const [facdashboardcount, setFacdashboardcount] = useState([]);
  const [facultyDetails, setFacultyDetails] = useState(null);
  const selection = useRowSelection(projectdata);

  function GetProjectStatusData() {
    CommonAxiosGet(`${config.url.FAC_URL}getFacultyDetails`).then((res) => {
      setProjectdata(res?.data?.scode === "01" ? res?.data?.fac_details || [] : []);
    });
  }

  function DashBoardCountFac() {
    CommonAxiosGet(`${config.url.FAC_URL}getUnvWisefacDashboardcount`).then((res) => {
      setFacdashboardcount(res?.data?.scode === "01" ? res?.data?.UnivsubWiseReport || [] : []);
    });
  }

  function handleSendBack(cfmsId) {
    Swal.fire({
      title: "Send Back to Maker?",
      text: `CFMS ID: ${cfmsId}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Send Back",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      backdrop: false,
    }).then((result) => {
      if (!result.isConfirmed) return;
      const url = `${config.url.FAC_URL}sendBackFacultyCfmsData?cfmsId=${cfmsId}`;
      CommonAxiosPost(url).then((res) => {
        if (res?.data?.scode === "01") {
          Swal.fire(res?.data?.sdesc || "Sent back successfully", "", "success");
          GetProjectStatusData();
        } else {
          Swal.fire(res?.data?.sdesc || "Operation failed", "", "error");
        }
      });
    });
  }

  function handleBulkApprove() {
    const slnoList = selection.selectedIds;

    if (slnoList.length === 0) {
      Swal.fire("Please select at least one faculty to approve", "", "warning");
      return;
    }

    const selectedFaculties = projectdata
      .filter((row) => slnoList.includes(row.sno))
      .map((row) => `${row.fac_name} (CFMS ID: ${row.cfms_id})`)
      .join("<br/>");

    Swal.fire({
      title: "Confirm Approval",
      html: `<strong>Selected Faculty:</strong><br/>${selectedFaculties}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve!",
      cancelButtonText: "Cancel",
      backdrop: false,
      confirmButtonColor: "#2e7d32",
    }).then((result) => {
      if (!result.isConfirmed) return;
      const url = `${config.url.FAC_URL}updateCheckerApprovalFaculty`;
      const payload = { isCheckerApproved: true, slnolist: slnoList };
      CommonAxiosPost(url, payload).then((res) => {
        if (res?.data?.scode === "01") {
          Swal.fire(res?.data?.sdesc || "Approved successfully", "", "success");
          selection.clear();
          GetProjectStatusData();
        } else {
          Swal.fire(res?.data?.sdesc || "Approval failed", "", "error");
        }
      });
    });
  }

  useEffect(() => {
    GetProjectStatusData();
    DashBoardCountFac();
  }, []);

  const totalCount = facdashboardcount.reduce((acc, item) => acc + Number(item.total || 0), 0);

  const columns = [
    selectColumn({ isChecker, selection }),
    textColumn("cfms_id", "CFMS ID", { alignLeft: false }),
    textColumn("fac_name", "Faculty Name"),
    textColumn("masked_aadhar", "Adhaar No"),
    textColumn("gender", "Gender", { alignLeft: false }),
    dateColumn("dob", "Date of Birth"),
    textColumn("designation", "Designation"),
    dateColumn("doj", "Date of Joining in the University"),
    textColumn("dept_name", "Department / Subject"),
    textColumn("fac_type_name", "Type of Faculty"),
    textColumn("appoint_cat_name", "Appointed Category"),
    textColumn("design_time_of_appointment", "Designation at the time of Appointment"),
    commaListColumn("qualification_appoint_name", "Qualifications at the Time of Appointment"),
    commaListColumn("qualification_later_name", "Qualification Acquired Later"),
    detailsColumn(setFacultyDetails),
    ...(isChecker ? [approveColumn(handleSendBack)] : []),
  ];

  const f = facultyDetails || {};
  const sections = [
    {
      title: "Personal Details",
      rows: [
        [["CFMS ID", f.cfms_id], ["Faculty Name", f.fac_name]],
        [["Aadhar", f.masked_aadhar], ["Gender", f.gender]],
        [["Date of Birth", f.dob], ["Caste", f.caste]],
        [["Sub Caste", f.sub_caste_name], ["Physically Challenged", f.is_ph ? "Yes" : "No"]],
        [["Type of Disability", f.type_of_disability], ["Disability Percentage", f.per_disability]],
      ],
    },
    {
      title: "Appointment Details",
      rows: [
        [["Designation", f.designation], ["Department", f.dept_name]],
        [["Date of Joining", f.doj], ["Faculty Type", f.fac_type_name]],
        [["Appointed Category", f.appoint_cat_name], ["District", f.dist_name]],
      ],
    },
    {
      title: "Contact Details",
      rows: [[["Mobile Number", f.contact], ["Email", f.email_id]]],
    },
    {
      title: "Qualification",
      rows: [
        [
          ["Qualification at Appointment", f.qualification_appoint_name],
          ["Qualification Acquired Later", f.qualification_later_name],
        ],
      ],
    },
  ];

  return (
    <>
      <FacultyDetailsModal
        show={!!facultyDetails}
        onHide={() => setFacultyDetails(null)}
        title="Faculty Complete Details"
        sections={sections}
        printRef={printRef}
        onPrint={handlePrint}
      />

      <FacultyReportLayout
        title={isChecker ? "Faculty Details Approval Form" : "Faculty Details Report"}
        data={projectdata}
        columns={columns}
        isChecker={isChecker}
        hasSelection={selection.hasSelection}
        onBulkApprove={handleBulkApprove}
      >
        {projectdata.length > 0 && (
          <div className="fac-dashboard-container">
            <div className="newdd-cards">
              <h5 className="fac-title">Total</h5>
              <div className="fac-count-box">
                <span className="fac-count-value">{totalCount}</span>
              </div>
            </div>

            {facdashboardcount.map((item) => (
              <div key={item.fac_type_name} className="newdd-cards">
                <h5 className="fac-title">{item.fac_type_name}</h5>
                <div className="fac-count-box">
                  <span className="fac-count-value">{item.total}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </FacultyReportLayout>
    </>
  );
}